import { Link, useLocation } from "react-router-dom";
import { canListActiveJobs, getOwner, getUser, hasRole, hasRoles, isRoot, useEnvironment, useScreen, useUnreadChatsCount } from "../../../core/Global";
import Icon from "../../base/Icon";
import Menu from "../../../core/Menu.json";
import { UserTypes } from "../../../core/Enums";
import { jobsBoardLink } from "../../../modules/crm/jobs/utils/jobsBoardState";




export default function AsideModulesMenu() {

    const env = useEnvironment()
    const screen = useScreen()
    const unreadChats = useUnreadChatsCount()
    const location = useLocation()
    const user = getUser()
    const owner = getOwner()


    return (
        <>
            {
                user?.isTech ?
                    (
                        // Voice-mode technicians get a single "Calls" entry (their calls history);
                        // in every other mode technicians have no module menu.
                        env.brand == "voice" ?
                            <div className="aside-menu flex-column-fluid" id="kt_aside_menu">
                                <div className="menu menu-column menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500 fw-semibold"
                                    id="#kt_aside_menu" data-kt-menu="true">
                                    <div className={"menu-item py-2" + (window.location.pathname.toLocaleLowerCase().startsWith("/voice/calls") ? " here" : "")}>
                                        <Link to="/voice/calls/history" className="menu-link menu-center">
                                            <span className="menu-icon me-0">
                                                <Icon icon="phone" type="light" />
                                            </span>
                                            <span className="menu-title">Calls</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            : <></>
                    )
                    :
                    <>
                        <div className="aside-menu flex-column-fluid" id="kt_aside_menu">
                            <div className={`${(screen.height < 760 ? "scroll-y" : "")}`} id="kt_aside_menu_wrapper" data-kt-scroll="true"
                                data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
                                data-kt-scroll-wrappers="#kt_aside, #kt_aside_menu" data-kt-scroll-offset="5px">
                                <div className="menu menu-column menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500 fw-semibold"
                                    id="#kt_aside_menu" data-kt-menu="true">
                                    {
                                        owner?.freeVoiceAccount ?
                                            <>
                                                {
                                                    user?.userType == UserTypes.Agent ?
                                                        <div className={"menu-item py-2" + (window.location.pathname.toLocaleLowerCase().startsWith(`/agents/view/${user.id}`) ? " here" : "")}>
                                                            <Link to={`/agents/view/${user.id}`} className="menu-link menu-center">
                                                                <span className="menu-icon me-0">
                                                                    <Icon icon="dashboard" type="light" />
                                                                </span>
                                                                <span className="menu-title">Dashboard</span>
                                                            </Link>
                                                        </div>
                                                        :
                                                        <div className={"menu-item py-2" + (window.location.pathname.toLocaleLowerCase().startsWith("/dashboard") ? " here" : "")}>
                                                            <Link to="/dashboard" className="menu-link menu-center">
                                                                <span className="menu-icon me-0">
                                                                    <Icon icon="dashboard" type="light" />
                                                                </span>
                                                                <span className="menu-title">Dashboard</span>
                                                            </Link>
                                                        </div>
                                                }

                                                {
                                                    hasRoles(["CallsHistory", "IsCustomer"]) &&
                                                    <div className={"menu-item py-2" + (window.location.pathname.toLocaleLowerCase().startsWith("/voice/calls") ? " here" : "")}>
                                                        <Link to="/voice/calls/history" className="menu-link menu-center">
                                                            <span className="menu-icon me-0">
                                                                <Icon icon="phone" type="light" />
                                                            </span>
                                                            <span className="menu-title">Calls</span>
                                                        </Link>
                                                    </div>
                                                }

                                                {
                                                    hasRoles(["ExtensionsList", "IsCustomer"]) &&
                                                    <div className={"menu-item py-2" + (window.location.pathname.toLocaleLowerCase().startsWith("/voice/pbx/extensions") ? " here" : "")}>
                                                        <Link to="/voice/pbx/extensions" className="menu-link menu-center">
                                                            <span className="menu-icon me-0">
                                                                <Icon icon="phone-office" type="light" />
                                                            </span>
                                                            <span className="menu-title">Extensions</span>
                                                        </Link>
                                                    </div>
                                                }

                                                {
                                                    hasRoles(["QueuesList", "IsCustomer"]) &&
                                                    <div className={"menu-item py-2" + (window.location.pathname.toLocaleLowerCase().startsWith("/voice/pbx/queues") ? " here" : "")}>
                                                        <Link to="/voice/pbx/queues" className="menu-link menu-center">
                                                            <span className="menu-icon me-0">
                                                                <Icon icon="users" type="light" />
                                                            </span>
                                                            <span className="menu-title">Queues</span>
                                                        </Link>
                                                    </div>
                                                }

                                                {
                                                    hasRoles(["ManageAdmins", "ManageAgents", "ManageTechnicians", "UserGroupsList", "ManageDepartmetns", "ManageShiftTypes", "ShiftCalendar"]) &&
                                                    <div className={"menu-item py-2" + (window.location.pathname.toLocaleLowerCase().startsWith("/accounts") ? " here" : "")}>
                                                        <Link to="/accounts" className="menu-link menu-center">
                                                            <span className="menu-icon me-0">
                                                                <Icon icon="user" type="light" />
                                                            </span>
                                                            <span className="menu-title">Accounts</span>
                                                        </Link>
                                                    </div>
                                                }

                                                <div className={"menu-item py-2" + (/^\/system(\/account|\/finance|\/general|\/announcements|\/firewall|\/?$)/i.test(window.location.pathname) ? " here" : "")}>
                                                    <Link to="/system/account/overview" className="menu-link menu-center">
                                                        <span className="menu-icon me-0">
                                                            <Icon icon="cog" type="light" />
                                                        </span>
                                                        <span className="menu-title fs-8">Settings</span>
                                                    </Link>
                                                </div>
                                            </>
                                            :
                                            <>

                                                {
                                                    !isRoot() && canListActiveJobs() &&
                                                    <div className={"menu-item py-2" + (/^\/boards\/(jobs|calendar|map)/i.test(window.location.pathname) ? " here" : "")}>
                                                        <Link to={jobsBoardLink(location)} className="menu-link menu-center">
                                                            <span className="menu-icon me-0">
                                                                <Icon icon="list-check" type="light" />
                                                            </span>
                                                            <span className="menu-title">Jobs</span>
                                                        </Link>
                                                    </div>
                                                }

                                                {
                                                    !isRoot() &&
                                                    <div className={"menu-item py-2" + (window.location.pathname.toLocaleLowerCase().startsWith("/chat") ? " here" : "")}>
                                                        <Link to="/chat" className="menu-link menu-center">
                                                            <span className="menu-icon me-0">
                                                                <Icon icon="message-lines" type="light" />
                                                            </span>
                                                            <span className="menu-title">Chat</span>
                                                        </Link>
                                                        {
                                                            unreadChats > 0 &&
                                                            <span className="aside-menu-badge">
                                                                <span className="badge badge-primary badge-circle">
                                                                    {unreadChats}
                                                                </span>
                                                            </span>
                                                        }

                                                    </div>
                                                }


                                                {
                                                    hasRole("HasCRM") && hasRoles(["ArchivedJobs", "IsCustomer", "ManageTechRates", "ManageSourceRates", "ManageJobTypeGroups", "ManageJobTypes", "ManageJobStatuses", "ManageJobSources", "ManageMetros", "ManageTags", "ManageFlags"]) &&
                                                    <div className={"menu-item py-2" + (window.location.pathname.toLocaleLowerCase().startsWith("/crm") ? " here" : "")}>
                                                        <Link to="/crm" className="menu-link menu-center">
                                                            <span className="menu-icon me-0">
                                                                <Icon icon="briefcase" type="light" />
                                                            </span>
                                                            <span className="menu-title">CRM</span>
                                                        </Link>
                                                    </div>
                                                }

                                                {
                                                    hasRoles(["ExtensionsList", "QueuesList", "ListActiveNumbers", "ListReleasedNumbers", "IsCustomer"]) ?
                                                        <div className={"menu-item py-2" + (window.location.pathname.toLocaleLowerCase().startsWith("/voice") ? " here" : "")}>
                                                            <Link to="/voice" className="menu-link menu-center">
                                                                <span className="menu-icon me-0">
                                                                    <Icon icon="phone-volume" type="light" />
                                                                </span>
                                                                <span className="menu-title">Voice</span>
                                                            </Link>
                                                        </div>
                                                        : hasRole("CallsHistory") &&
                                                        <div className={"menu-item py-2" + (window.location.pathname.toLocaleLowerCase().startsWith("/voice/calls/history") ? " here" : "")}>
                                                            <Link to="/voice/calls/history" className="menu-link menu-center">
                                                                <span className="menu-icon me-0">
                                                                    <Icon icon="phone" type="light" />
                                                                </span>
                                                                <span className="menu-title">Calls</span>
                                                            </Link>
                                                        </div>
                                                }

                                                {
                                                    hasRoles(["ManageAdmins", "ManageAgents", "ManageTechnicians", "UserGroupsList", "ManageDepartmetns", "ManageShiftTypes", "ShiftCalendar"]) &&
                                                    <div className={"menu-item py-2" + (window.location.pathname.toLocaleLowerCase().startsWith("/accounts") ? " here" : "")}>
                                                        <Link to="/accounts" className="menu-link menu-center">
                                                            <span className="menu-icon me-0">
                                                                <Icon icon="user" type="light" />
                                                            </span>
                                                            <span className="menu-title">Accounts</span>
                                                        </Link>
                                                    </div>
                                                }

                                                {
                                                    /* Rinvox's own migration board -- who is still on the old
                                                       subscription and who is on a new plan. Root only. */
                                                    isRoot() &&
                                                    <div className={"menu-item py-2" + (window.location.pathname.toLocaleLowerCase().startsWith("/migration") ? " here" : "")}>
                                                        <Link to="/migration" className="menu-link menu-center">
                                                            <span className="menu-icon me-0">
                                                                <Icon icon="arrow-right-arrow-left" type="light" />
                                                            </span>
                                                            <span className="menu-title fs-8">Migration</span>
                                                        </Link>
                                                    </div>
                                                }

                                                {
                                                    /* The plans Rinvox sells and every figure on them. Root only. */
                                                    isRoot() &&
                                                    <div className={"menu-item py-2" + (window.location.pathname.toLocaleLowerCase().startsWith("/plan-catalog") ? " here" : "")}>
                                                        <Link to="/plan-catalog" className="menu-link menu-center">
                                                            <span className="menu-icon me-0">
                                                                <Icon icon="layer-group" type="light" />
                                                            </span>
                                                            <span className="menu-title fs-8">Plans</span>
                                                        </Link>
                                                    </div>
                                                }

                                                {
                                                    /* Enterprise offers: build, send and follow them. Root only for now. */
                                                    isRoot() &&
                                                    <div className={"menu-item py-2" + (window.location.pathname.toLocaleLowerCase().startsWith("/enterprise") ? " here" : "")}>
                                                        <Link to="/enterprise" className="menu-link menu-center">
                                                            <span className="menu-icon me-0">
                                                                <Icon icon="building" type="light" />
                                                            </span>
                                                            <span className="menu-title fs-8">Enterprise</span>
                                                        </Link>
                                                    </div>
                                                }

                                                {
                                                    !isRoot() && hasRole("HasCRM") && hasRoles(["JobsReport", "IsCustomer", "ManageBalanceSheet"]) &&
                                                    <div className={"menu-item py-2" + (window.location.pathname.toLocaleLowerCase().startsWith("/reports") ? " here" : "")}>
                                                        <Link to="/reports/jobs" className="menu-link menu-center">
                                                            <span className="menu-icon me-0">
                                                                <Icon icon="chart-line" type="light" />
                                                            </span>
                                                            <span className="menu-title">Reports</span>
                                                        </Link>
                                                    </div>
                                                }

                                                {
                                                    hasRole("HasCRM") && hasRoles(["ManageInventoryItems", "ManageWarehouseContainers", "ManageCategories", "ManageBrands", "ManageBrandModels", "ManageVendors", "ManageColors", "ManageUnits"]) &&
                                                    <div className={"menu-item py-2" + (window.location.pathname.toLocaleLowerCase().startsWith("/inventory") ? " here" : "")}>
                                                        <Link to="/inventory" className="menu-link menu-center">
                                                            <span className="menu-icon me-0">
                                                                <Icon icon="barcode-scan" type="light" />
                                                            </span>
                                                            <span className="menu-title">Inventory</span>
                                                        </Link>
                                                    </div>
                                                }

                                                <div className={"menu-item py-2" + (/^\/system(\/account|\/finance|\/general|\/announcements|\/firewall|\/?$)/i.test(window.location.pathname) ? " here" : "")}>
                                                    <Link to="/system/account/overview" className="menu-link menu-center">
                                                        <span className="menu-icon me-0">
                                                            <Icon icon="cog" type="light" />
                                                        </span>
                                                        <span className="menu-title fs-8">System</span>
                                                    </Link>
                                                </div>

                                            </>
                                    }

                                </div>
                            </div>

                        </div>
                    </>
            }
        </>
    )
}